export default __webpack_public_path__ + "static/media/DL.2179ac4d.svg";